export default "/assets/tonlabs-black.png";